import React, { ReactElement, ReactNode } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { BiLink, BiBasketball } from 'react-icons/bi';
import { LinkContainer } from 'react-router-bootstrap';
import { Activite } from '../../../../../common/src/entities';

export interface ChampsAssociesItem {
    id: number;
    name: ReactNode;
}

export interface PropsChampsAssocies {
    titre: string;
    url: string;
    items: ChampsAssociesItem[];
    labelCol: number;
    montrerActifInactif?: boolean;
}

export default function ChampsAssocies(props: PropsChampsAssocies): ReactElement {
    const { titre, items, url, labelCol, montrerActifInactif } = props;

    const sortedItems = items.sort((a, b) => {
        const aActif = (a as Activite).actif === true || false;
        const bActif = (b as Activite).actif === true || false;
        return aActif === bActif ? 0 : aActif ? -1 : 1;
    });

    const cssCardBody: React.CSSProperties = {
        padding: 0,
        minHeight: 30,
    };

    return (
        <Form.Group>
            <Row>
                <Col xs={labelCol}>{titre}</Col>
                <Col>
                    <Card>
                        <Card.Body style={cssCardBody}>
                            {sortedItems?.map((item, index) => (
                                <div className="d-flex align-items-center" key={index}>
                                    <LinkContainer to={`../../${url}/` + item.id}>
                                        <Button variant="link" className="btn-sm text-muted">
                                            <BiLink size="1.5em" />
                                        </Button>
                                    </LinkContainer>
                                    <LinkContainer to={`../../../${url}/` + item.id}>
                                        <Button variant="link" className="btn-sm text-muted">
                                            <BiBasketball size="1.5em" />
                                        </Button>
                                    </LinkContainer>
                                    <Col>{item.name}</Col>
                                    {montrerActifInactif && (
                                        <Col>
                                            <span>{(item as Activite).actif === true ? 'Actif' : 'Inactif'}</span>
                                        </Col>
                                    )}
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Form.Group>
    );
}
